import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";

function QueryModal({ show, onHide, meetingId, empId, onQuerySubmitted }) {
  const [selectedEmp, setSelectedEmp] = useState("");
  const [message, setMessage] = useState("");
  const [empList, setEmpList] = useState([]);
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const isBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");

  useEffect(() => {
    if (empId) {
      utils
        .callAPI("get", `/meeting/list-hierarchy?emp_id=${empId}&is_bm=${isBM ?'no':'yes'}`)
        .then((res) => Array.isArray(res) && setEmpList(res))
        .catch(() => {});
    }
  }, [empId]);

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("meeting_id", meetingId);
    formData.append("receiver_id", selectedEmp);
    formData.append("query", message);
    formData.append("comment_id", 0);
    formData.append("parent_id", 0);

    utils.callAPI("post", "meeting/query-add", formData).then(() => {
      setSelectedEmp("");
      setMessage("");
      onHide();
      onQuerySubmitted();
    });
  };

  const filteredEmpList = empList?.filter(
    (emp) => emp?.id !== userProfile?.employeeId
  );

  return (
    <RB.Modal show={show} onHide={onHide} size="lg">
      <RB.Modal.Header closeButton>
        <h6>Query To:</h6>
        <RB.Form.Select
          value={selectedEmp}
          onChange={(e) => setSelectedEmp(e.target.value)}
        >
          <option value="">Select Employee</option>
          {filteredEmpList.map((emp) => (
            <option key={emp.id} value={emp.id}>
              {emp.firstName} {emp.lastName}
            </option>
          ))}
        </RB.Form.Select>
      </RB.Modal.Header>
      <RB.Modal.Body>
        <RB.Form.Group>
          <RB.Form.Label>Message</RB.Form.Label>
          <RB.Form.Control
            as="textarea"
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </RB.Form.Group>
      </RB.Modal.Body>
      <RB.Modal.Footer>
        <RB.Button variant="secondary" onClick={onHide}>
          Cancel
        </RB.Button>
        <RB.Button
          variant="primary"
          disabled={!selectedEmp || !message}
          onClick={handleSubmit}
        >
          Submit FeedBack
        </RB.Button>
      </RB.Modal.Footer>
    </RB.Modal>
  );
}

export default QueryModal;
